import { createPortal } from 'react-dom'
import { lienWhatsApp } from '../../../content/contact'
import { TEAL, VERT, CREME, ORANGE, teinte } from './dossierUi'

const CHEMINS = [
  {
    e: '🌾', t: 'Vous cultivez', s: 'Jardin, petite parcelle',
    d: 'Le statut de cotisant de solidarité, auprès de la CGSS Martinique (service des exploitants agricoles). Pensé pour les petites surfaces, avec une cotisation calculée sur vos revenus.',
  },
  {
    e: '🧾', t: 'Vous transformez, cuisinez ou créez', s: 'Jus, plats, artisanat…',
    d: 'La micro-entreprise : gratuite et en ligne, sur le guichet unique des formalités d\'entreprise (formalites.entreprises.gouv.fr).',
  },
]

/**
 * Fiche « Pas encore déclaré ? » (prototype v7.5). « Être accompagné » ouvre
 * WhatsApp directement : la porte « Aide & contact » reste « Bientôt » (S61),
 * on ne la rouvre pas par ce biais (brief §5.3).
 */
function FeuilleDeclaration({ enCours, onClose, onDemarcheLancee }) {
  return createPortal(
    <div
      className="fixed inset-0 z-[60] flex items-end"
      role="dialog"
      aria-modal="true"
      style={{ background: 'rgba(4,25,24,0.5)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)' }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full overflow-y-auto panel-slide-up"
        style={{
          background: CREME, borderRadius: '28px 28px 0 0', maxHeight: '88dvh',
          padding: '18px 20px calc(24px + env(safe-area-inset-bottom))',
        }}
      >
        <div className="w-[42px] h-1 rounded-full mx-auto mb-4" style={{ background: 'rgba(7,62,61,0.15)' }} />
        <p className="text-[11px] font-bold uppercase" style={{ letterSpacing: 2, color: TEAL }}>Pas encore déclaré ?</p>
        <p className="font-serif text-[23px] mt-[3px] leading-tight" style={{ color: VERT }}>Se déclarer, c'est plus simple qu'on ne croit</p>
        <p className="text-[12.5px] leading-relaxed mt-2" style={{ color: 'rgba(7,62,61,0.65)' }}>
          Pour exposer au marché, la mairie demande que chaque exposant ait un statut. Deux chemins simples :
        </p>
        {CHEMINS.map((c) => (
          <div key={c.t} className="glass-surface rounded-[18px] mt-2.5" style={{ padding: '14px 15px' }}>
            <div className="flex items-center gap-2.5">
              <span className="text-[22px]">{c.e}</span>
              <div>
                <p className="text-sm font-bold" style={{ color: VERT }}>{c.t}</p>
                <p className="text-[11px]" style={{ color: 'rgba(7,62,61,0.5)' }}>{c.s}</p>
              </div>
            </div>
            <p className="text-[12.5px] leading-relaxed mt-2" style={{ color: 'rgba(7,62,61,0.72)' }}>{c.d}</p>
          </div>
        ))}
        <p className="text-[12px] leading-relaxed mt-3" style={{ color: 'rgba(7,62,61,0.62)' }}>
          Dès que la démarche est lancée, choisissez « Déclaration en cours » : vous continuez à exposer pendant qu'elle aboutit.
        </p>
        {!enCours && (
          <button onClick={onDemarcheLancee} className="mt-3.5 w-full rounded-2xl text-[15px] font-extrabold" style={{ padding: 15, background: VERT, color: CREME }}>
            Ma démarche est lancée
          </button>
        )}
        <a
          href={lienWhatsApp('Bonjour Manrina, je voudrais être accompagné pour me déclarer (dossier exposant).')}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 w-full rounded-2xl text-[13.5px] font-extrabold block text-center"
          style={{ padding: 13, background: teinte(ORANGE, 0.14), color: VERT }}
        >
          Être accompagné par Manrina ›
        </a>
        <button onClick={onClose} className="mt-1.5 w-full rounded-2xl text-[13px] font-bold" style={{ padding: 12, color: 'rgba(7,62,61,0.5)' }}>
          Fermer
        </button>
      </div>
    </div>,
    document.body,
  )
}

export default FeuilleDeclaration
